module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p13-e0f6bee3de11fc7dc40c9da51d342317.png";